import { CommonActionKey } from "common";

enum CustomActionKey {
  GenerateEmail = "generateEmail",
  Send = "send",
}

export const SharedActionKey = {
  ...CommonActionKey,
  ...CustomActionKey,
};
